<template>
  <div>
    <Dropdown
      v-model="selectedServico"
      @change="test($event)"
      :options="servicos"
      optionLabel="idServico.detail"
      placeholder="Selecione um Serviço"
    />
  </div>
</template>

<script>
import ContribuinteServicoService from "../services/tributario/contribuinte.servico.service";

export default {
  name: "servContr",
  props:['teste'],
  data() {
    return {
      servicos: null,
      selectedServico: null
    };
  },
  created() {
    ContribuinteServicoService.findAllServicos().then(servico => {
      this.servicos = servico.data;
    });
  },methods:{
    test(event){
      console.log(event.value);
      this.$emit('update:teste',event.value)
    }
  }
};
</script>

<style scoped>
</style>